import { sqliteTable, text, integer, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// salary_components — รายการเงินเดือน (Salary Component)
// ============================================================================
export const salaryComponents = sqliteTable("hr_salary_components", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  salaryStructureId: text("salary_structure_id").notNull(),
  name: text("name").notNull(), // เงินเดือน, ค่าล่วงเวลา, ภาษี, ประกันสังคม, etc.
  type: text("type").notNull(), // earning or deduction
  calculationType: text("calculation_type").notNull().default("fixed"), // fixed, percentage, formula
  amount: real("amount").notNull().default(0),
  percentage: real("percentage"), // if calculation_type=percentage
  isTaxable: integer("is_taxable").notNull().default(1),
  isStatutory: integer("is_statutory").notNull().default(0), // ตามกฎหมาย (ภาษี, ประกันสังคม)
  sortOrder: integer("sort_order").notNull().default(0),
  // Audit columns
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  sc_structure_idx: index("sc_structure_idx").on(table.salaryStructureId),
  sc_company_idx: index("sc_company_idx").on(table.companyId),
}));

// Type exports
export type SalaryComponent = typeof salaryComponents.$inferSelect;
export type NewSalaryComponent = typeof salaryComponents.$inferInsert;
